import { emptySplitApi } from "./InjectionEndpoint"

const calendarHoursUserService = emptySplitApi.injectEndpoints({
    endpoints: (build) => ({
        
        getSediVisibili: build.query({
            query: () => `/api/Appuntamenti/sedi-visibili`,
            providesTags: ['appointments']
        }),

        getAppuntamentiMese: build.query({
            query: (params: any) => `/api/Appuntamenti/${params.sedeChiave}/${params.anno}/${params.mese}`,
            providesTags: ['appointments']
        }),

        getAppointmentsLocationDay: build.query({
            query: (params: any) => `/api/Appuntamenti/${params.sedeChiave}/${params.anno}/${params.mese}/${params.giorno}`,
            providesTags: ['appointments']
        }),

    }),
})

export const {
    useGetSediVisibiliQuery,
    useGetAppuntamentiMeseQuery,
    useGetAppointmentsLocationDayQuery
} = calendarHoursUserService;